import { ChipType } from "@homebound/beam";
import { BillStatus, BillType, CommitmentStatus } from "src/generated/graphql-types";
import { foldEnum } from "./utils";

export type CommitmentStatusName = ReturnType<typeof commitmentStatusToNameMapper>;
export function commitmentStatusToNameMapper(status: CommitmentStatus) {
  return status === CommitmentStatus.Voided
    ? "Voided"
    : status !== CommitmentStatus.Signed
    ? "Needs Signature"
    : "Released";
}

export function commitmentStatusNameToChipTypeMapper(name: CommitmentStatusName): ChipType {
  return foldEnum(name, {
    Voided: "neutral",
    "Needs Signature": "caution",
    Released: "info",
  });
}

/**
 * Simplify trade facing PO status for c2p launch:
 *
 * 1. Needs Signature: Lot released commitments are autosigned but
 * manual commitments may not yet have been signed, surface this.
 *
 * 2. Released: PO signed by both parties
 *
 * 3. Voided
 *
 */
export function commitmentStatusToChipTypeMapper(
  status: CommitmentStatus,
): [type: ChipType, label: CommitmentStatusName] {
  const name = commitmentStatusToNameMapper(status);
  return [commitmentStatusNameToChipTypeMapper(name), name];
}

export function billStatusChipTypeMapper(type: BillType, status: BillStatus): [type: ChipType, label: string] {
  const isautoBill = [BillType.Deferred, BillType.Immediate].includes(type);

  if (isautoBill) {
    // Todo: Verify bill statuses we want to filter from Trade Client
    // - Filter out Draft, Ready, on BE
    if (status === BillStatus.Ready || status === BillStatus.Requested) return ["caution", "Needs Approval"];
    if (status === BillStatus.ChangesRequested) return ["warning", "Changes Requested"];
  }

  return foldEnum(status, {
    [BillStatus.Requested]: ["caution", "In Review"],
    [BillStatus.Approved]: ["info", "Processing"],
    [BillStatus.Paid]: ["success", "Paid"],
    [BillStatus.Void]: ["neutral", "Voided"],
    [BillStatus.Rejected]: ["warning", "Rejected"],
    else: ["caution", "In Review"], // Consider change requested status for manuals as still in review
  });
}
